import { Box } from '@mui/material';
import React from 'react'
import GitHubCalendar from "react-github-calendar";
import {useTheme} from '@mui/material';
import { tokens } from '../../theme';
const Github = () => {
  const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  return (
   <Box display='flex' flexDirection='column' textAlign='center' justifyContent='center'>
        <h1 className="project-heading" text-center style={{ paddingBottom: "20px" }}>
        Days I <strong style={{ color: colors.blueAccent[400] }}>Code</strong>
      </h1>
      <GitHubCalendar
        username="abhishek-reddy-1999"
        blockSize={15}
        blockMargin={5}
        color='#0077b6'
        fontSize={16}
      />
   </Box>
  )
}

export default Github